import React from "react";

/**
 * Dashboard status label — tags, flags, badges, priority markers (10px / 16px height).
 * Add colour classes via className (e.g. bg-freshgreen text-white).
 */
const DashboardStatusLabel = ({ as: Tag = "span", children, className = "", ...rest }) => (
  <Tag className={`dashboard-status-label ${className}`.trim()} {...rest}>
    {children}
  </Tag>
);

export default DashboardStatusLabel;
